module.exports = __webpack_public_path__ + "img/i-sec01-img04.ebf07573.png";